module.exports = __webpack_public_path__ + "img/4.b0f8d10f.jpg";